import { isMinor } from '@bordrio/shared';
import { NifOrderFragment } from '@src/generated/graphql';

export function isNifOrderMinor(order: NifOrderFragment): boolean {
  return isMinor(new Date(order.birthDate));
}
